import zkteco from "./zkteco"
const Pages = {
    ...zkteco.Pages
}

const Reducers = {
    ...zkteco.Reducers
}

export default {
    Pages,
    Reducers
}